import React from "react";
import { Field, ErrorMessage } from "formik";
import ReCAPTCHA from "react-google-recaptcha";

import { useMembershipRegistrationContext } from "../../context/MembershipRegistrationContext";

export default function TermsAndConditionsComponent() {
  const { setCaptchaValue } = useMembershipRegistrationContext();

  return (
    <div
      className="col-12 my-0 rounded-3 p-4"
      style={{
        border: "1px solid #e9ecef",
        backgroundColor: "#fff",
      }}
    >
      <h4 className="fw-bold mb-4">Terms and Conditions</h4>
      <div className="alert alert-primary" role="alert">
        <ol className="mb-0">
          <li>
            I confirm that all the details provided are correct and accurate to
            the best of my knowledge.
          </li>
          <li>
            I acknowledge that Old Boys' Association of Vidyaloka College will
            securely store my data in its database.
          </li>
          <li>
            I agree that my contact details may be used to send announcements,
            event updates, and greeting messages.
          </li>
          <li>
            I understand that no refund will be provided under any
            circumstances.
          </li>
          <li>
            I consent to the processing and storage of my personal data in
            compliance with applicable data protection and privacy regulations.
          </li>
          <li>
            I understand that my data may be retained for record-keeping and
            administrative purposes as required by the association.
          </li>
          <li>
            I acknowledge that I may contact Old Boys' Association of Vidyaloka
            College to request corrections or updates to my personal
            information.
          </li>
        </ol>
      </div>

      <div className="form-check mt-3">
        <Field
          type="checkbox"
          name="termsAccepted"
          className="form-check-input"
          id="acceptTerms"
        />
        <label className="form-check-label" htmlFor="acceptTerms">
          I have read and agree to the above Terms and Conditions.
          <span className="text-danger">*</span>
        </label>
        <ErrorMessage name="accepted" component="div" className="text-danger" />
      </div>

      <div className="my-3">
        <ReCAPTCHA
          sitekey="6LcPOAwsAAAAAAe1MsP0lrmAskDk0gYwIOw3YbIc"
          onChange={(value) => setCaptchaValue(value)}
        />
      </div>
    </div>
  );
}
